'use strict';

/* global $ dataLayer FormData */

import device from './../../helper/device';

let current_fs, next_fs, previous_fs;
let left, opacity, scale;
let animating;

export function zipcodeRestrict () {
    let input_zipcode = [];
    $('[name="zipcode"]').each(function (i) {
        input_zipcode[i] = this.defaultValue;
        $(this).data('idx', i); // save this field's index to access later
    });
    $('[name="zipcode"]').on('keyup', function (e) {
        let input = $(this);
        let input_val = input.val();
        if (input_val === '') {
            return;
        }
        if (!input_val.match(/[0-9]/g)) {
            input.val(input_zipcode[+input.data('idx')]);
            return;
        }
        if (input_val.length > +input.attr('maxlength')) {
            input_val = input_val.slice(0, +input.attr('maxlength'));
            input.val(input_val);
        }
        input_zipcode[+input.data('idx')] = input_val;
    });
}

export function goToNextStep (el) {
    if (animating) return false;
    animating = true;

    current_fs = el.closest('.formStep');
    next_fs = el.closest('.formStep').next();

    next_fs.find('.errorList').empty();
    next_fs.show();
    current_fs.animate({
        opacity: 0
    }, {
        step: function (now) {
            scale = 1 - (1 - now) * 0.2;
            left = ((now * 50) + 50) + '%';
            opacity = 1 - now;

            if (device.isMobile()) {
                current_fs.css({
                    'transform': 'translateX(-50%) scale(' + scale + ')'
                });
            } else {
                current_fs.css({
                    'transform': 'translate(-50%, -50%) scale(' + scale + ')'
                });
            }

            next_fs.css({
                'left': left,
                'opacity': opacity
            });
        },
        duration: 600,
        complete: function () {
            current_fs.hide();
            gtm_virtualpage_track(next_fs);
            animating = false;
        }
    });
}

export function goToPrevStep (el) {
    if (animating) return false;
    animating = true;

    current_fs = el.closest('.formStep');
    previous_fs = el.closest('.formStep').prev();

    previous_fs.find('.errorList').empty();
    previous_fs.show();
    current_fs.animate({
        opacity: 0
    }, {
        step: function (now, mx) {
            scale = 0.8 + (1 - now) * 0.2;
            left = (((1 - now) * 50) + 50) + '%';
            opacity = 1 - now;
            current_fs.css({
                'left': left
            });

            if (device.isMobile()) {
                previous_fs.css({
                    'transform': 'translateX(-50%) scale(' + scale + ')',
                    'opacity': opacity
                });
            } else {
                previous_fs.css({
                    'transform': 'translate(-50%, -50%) scale(' + scale + ')',
                    'opacity': opacity
                });
            }
        },
        duration: 800,
        complete: function () {
            current_fs.hide();
            gtm_virtualpage_track(previous_fs);
            animating = false;
        }
    });
}

export let gtm_virtualpage_track = (element) => {
    console.log('dataLayer', dataLayer, $(element).data('gtm-virtualpage-url'), $(element).data('gtm-virtualpage-title'));
    if ($(element).data('gtm-virtualpage-url') && $(element).data('gtm-virtualpage-title')) {
        dataLayer.push({
            'event': 'VirtualPageview',
            'virtualPageURL': $(element).data('gtm-virtualpage-url'),
            'virtualPageTitle': $(element).data('gtm-virtualpage-title')
        });
    }
};

export let objectifyForm = (serializeArray) => {
    let formData = new FormData();
    for (let i = 0, l = serializeArray.length; i < l; i++) {
        formData.append(serializeArray[i]['name'], serializeArray[i]['value']);
    }
    return formData;
};

export let jsonifyForm = (serializeArray) => {
    let json = {};
    for (let i = 0, l = serializeArray.length; i < l; i++) {
        json[serializeArray[i]['name']] = serializeArray[i]['value'];
    }
    return json;
};



// WEBPACK FOOTER //
// ./front/js/modules/forms/_form_functions.js